import mix from "mix-color"

export const colors = ["#98DDCA", "#D5ECC2", "#FFD3B4", "#FFAAA7"];
export const colorsBlue = ["#8888FF", "#0000FF", "#0000BB", "#000088"];
export const colors5 = colors.slice()
colors5.push("#AAAAAA")


export const mixColor = (percent, pal, colorsList = colors) => {
    const idx = Math.floor(percent * (colorsList.length - 1))
    const alpha = (percent * (colorsList.length - 1)) - idx
    const R2 = pal && pal[0] && pal[0].name === "R2"
    const clr = !(R2) ? colorsList.slice() : colorsList.slice().reverse();
    return idx >= clr.length - 1 ? clr[clr.length - 1] : mix(clr[idx], clr[idx + 1], alpha)
}

export const grayScale = (color) => {

}